import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TableContext from "context/table/tableContext";
import { FILTER_NAMES, filterBlockStyle, TRUE, useMediaQueries } from "shared";

import FilterButton from "../components/FilterButton";
import FilterMenu from "../components/FilterMenu";
import FilterDropdown from "../FilterDropdown";
import { useFilters } from "../hooks";

export const RoleFilters = () => {
    const { hasNoPermissionToRead } = useContext(TableContext);

    const { t } = useTranslation();
    const { fromSm, toMd, fromLg } = useMediaQueries();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useFilters();

    const additionalParams = `${[FILTER_NAMES.IncludeStatic]}=${TRUE}`;

    return (
        <div css={css(filterBlockStyle)}>
            {(fromSm && toMd) || fromLg ? (
                <FilterDropdown
                    filter={FILTER_NAMES.Permission}
                    placeholder={t("Filter##permission")}
                    additionalParams={additionalParams}
                    disabled={hasNoPermissionToRead}
                />
            ) : (
                <>
                    <FilterButton
                        onOpen={handleOpenMenu}
                        isDisabled={hasNoPermissionToRead}
                    >
                        {t("Button##filters")}
                    </FilterButton>

                    <FilterMenu
                        isOpen={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleCloseMenu}
                    >
                        <div>
                            <FilterDropdown
                                filter={FILTER_NAMES.Permission}
                                placeholder={t("Filter##permission")}
                                additionalParams={additionalParams}
                            />
                        </div>
                    </FilterMenu>
                </>
            )}
        </div>
    );
};
